import type { Axios } from "axios";

export * from "./getRecordingsListForProspect";
export * from "./getRecordingTypes";
export * from "./toggleSummaryLivingStoryInclusion";
export * from "./toggleNotesLivingStoryInclusion";
export * from "./updateRecordingNotes";

export const startRecordingSession = async (
  secureAxios: Axios,
  sessionId: string,
  startedDate: string,
  prospectId: number,
  recordingTitle: string,
  recordingTypeId: number
) => {
  const resp = await secureAxios.post("/recordings/start", {
    newSessionId: sessionId,
    startedDate: startedDate,
    prospectId: prospectId,
    recordingTitle: recordingTitle,
    recordingTypeId: recordingTypeId
  });
  if (resp.status !== 200) {
    throw new Error(`Failed to start recording session (${resp.status})`);
  }
};

export const uploadRecordingChunk = async (
  secureAxios: Axios,
  sessionId: string,
  startedDate: string,
  newDurationMs: number,
  sequenceNumber: number,
  audioChunk: Blob
) => {
  const formData = new FormData();
  formData.append("audioChunk", audioChunk);
  formData.append("sessionId", sessionId);
  formData.append("startedDate", startedDate);
  formData.append("newDurationMs", newDurationMs.toString());
  formData.append("sequenceNumber", sequenceNumber.toString());

  const resp = await secureAxios.post("/recordings/chunk", formData);
  if (resp.status !== 202) {
    throw new Error(`Failed to upload recording chunk (${resp.status})`);
  }
};

export const finishRecordingSession = async (
  secureAxios: Axios,
  sessionId: string,
  startedDate: string,
  durationMs: number
) => {
  const resp = await secureAxios.post("/recordings/finish", {
    sessionId: sessionId,
    startedDate: startedDate,
    durationMs: durationMs
  });
  if (resp.status !== 200) {
    throw new Error(`Failed to finish recording session (${resp.status})`);
  }
};
